import $ from "jquery";
import { services } from "../services/notificationService";

let dataSet = [];

function init() {
    $(document).on("keydown", function(event) {
        if (event.which === 13) {
            btnSearchSitesClick();
        }
    });
    $(document).on("submit", "#addPersonSiteForm", function() { return false; });
    $(document).on("click", "#btnSearchSites", function() {
        $("#searchSitesResultsTable").DataTable().clear();
        $("#searchSitesResultsTable").DataTable().destroy();
        const searchKeyword = $("#searchKeyword").val();
        const active = $("#searchActive").is(":checked");
        const inactive = $("#searchInActive").is(":checked");
        const container = $("#searchSiteResults");
        $.get("/api/site/searchsite", { searchKeyword: searchKeyword, active: active, inactive: inactive }, function(data) {
            container.removeClass("hidden");
            buildDataSet(data.results);
            buildTable();
        });
    });
    $(document).on("click", "#addSitebtn", function(e) {
        const siteList = $("input:checkbox[name='siteId']:checked").map(function() {
            return this.value;
        }).get().join(",");
        
        if (siteList === "") {
            $("#AddSiteValidationMessage").show();
        } else {
            $("#AddSiteValidationMessage").hide();

            const personId = $("#personId").val();
            const container = $("#sites");

            $.post("/api/site/addpersonsite", { siteId: siteList, personId: personId }, function(data) {
                $("#searchSitesResultsTable").DataTable().clear();
                $("#searchSitesResultsTable").DataTable().destroy();
                $("#searchKeyword").val("");
                $("#searchActive").prop("checked", true);
                container.html(data);
                services.notificationService.success("Successfully added site(s).");
                $("body").removeClass("modal-open");
                $(".modal-backdrop").remove();
            }).done(function() {
                $("#addPersonSite").modal("hide");
            });
        }
    });
}

function btnSearchSitesClick() {
    $("#btnSearchSites").click();
}

function buildDataSet(sites) {
    dataSet = [];
    for (let i = 0; i < sites.length; i++) {
        dataSet.push([sites[i].siteId, sites[i].siteName, sites[i].city, sites[i].state, sites[i].country, sites[i].region, sites[i].regionDescription, sites[i].area, sites[i].siteId, sites[i].isActive]);
    }
}
function buildTable() {
    $("#searchSitesResultsTable").DataTable({
        "serverSide": false,
        "filter": false,
        "data": dataSet,
        "bLengthChange": false,
        "bPaginate": false,
        "PageLength": 15,
        "bInfo": false,
        "ordering": false,
        "columnDefs":
            [
                {
                    "targets": 0,
                    mRender: function(data, type, row) {
                        if (data === undefined) return "";
                        return "<input name='siteId' type='checkbox' value='" + data + "'></input>";
                    }
                },
                {
                    "targets": 1,
                    "name": "Site Name"
                },
                {
                    "targets": 2,
                    "name": "City"
                },
                {
                    "targets": 3,
                    "name": "State"
                },
                {
                    "targets": 4,
                    "name": "Country"
                },
                {
                    "targets": 5,
                    "name": "Region",
                    mRender: function(data, type, row) {
                        if (data === undefined) return "";
                        return "<div>" + data + "</div>";
                    }
                },
                {
                    "targets": 6,
                    "name": "Description",
                    "visible": false
                },
                {
                    "targets": 7,
                    "name": "Approval Area"
                },
                {
                    "targets": 8,
                    "name": "Site ID"
                },
                {
                    "targets": 9,
                    "name": "Status",
                    mRender: function(data, type, row) {
                        if (data === undefined) return "";
                        return "<i class='fa fa-circle' style='color: " +
                            (!data ? "Red" : "Green") +
                            "'></i> " +
                            (data ? "Active" : "Inactive");
                    }
                }
            ]
    });
}

export const addPersonSite = {
    init: init,
    btnSearchSitesClick: btnSearchSitesClick
};